<app-common-header [isAdminOrTutor]="true"></app-common-header>
<div class="body">
  <div class="mainContent question-bank">
    <!-- Questions Bank Section -->
    <ng-container *ngIf="!isDataLoading">
      <!-- Filter menu -->
      <div class="question-bank__filter-menu">
        <mat-form-field>
          <mat-label>Courses</mat-label>
          <mat-select
            [(ngModel)]="selectedCourseIndex"
            (selectionChange)="selectCourse()"
          >
            <mat-option
              *ngFor="let course of courses; let courseIndex = index"
              [value]="courseIndex"
              >{{ course.testTypeName }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Sections</mat-label>
          <mat-select
            [(ngModel)]="selectedSectionIndex"
            (selectionChange)="selectSection()"
          >
            <mat-option
              *ngFor="let section of sections; let sectionIndex = index"
              [value]="sectionIndex"
              >{{ section.test_section }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Topics</mat-label>
          <mat-select
            [(ngModel)]="selectedTopic"
            (selectionChange)="selectTopic($event)"
          >
            <mat-option
              *ngFor="let topic of topics; let topicIndex = index"
              [value]="topicIndex"
              >{{ topic.topic_name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Sub-Topic</mat-label>
          <mat-select
            [(ngModel)]="selectedSubTopic"
            (selectionChange)="getQuestions()"
          >
            <mat-option
              *ngFor="let subTopic of subTopics; let subTopicIndex = index"
              [value]="subTopicIndex"
              >{{ subTopic.subtopic_name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Difficulty Level</mat-label>
          <mat-select
            [(ngModel)]="selectedLevel"
            (selectionChange)="getQuestions()"
          >
            <mat-option [value]="0">All</mat-option>
            <mat-option
              *ngFor="let level of difficultyLevels"
              [value]="level.tdlId"
              >{{ level.levelDescription }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Question Type</mat-label>
          <mat-select
            [(ngModel)]="selectedQuestionType"
            (selectionChange)="getQuestions()"
          >
            <mat-option [value]="0">All</mat-option>
            <mat-option [value]="1">MCQ</mat-option>
            <mat-option [value]="2">Free response</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Question Category</mat-label>
          <mat-select
            [(ngModel)]="selectedQuestionCategory"
            (selectionChange)="getQuestions()"
          >
            <mat-option [value]="0">All</mat-option>
            <mat-option
              *ngFor="
                let category of questionCategories;
                let categoryIndex = index
              "
              [value]="categoryIndex + 1"
              >{{ category.label }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <span
          class="question-bank__filter-menu__create-question button"
          (click)="goToCreateQuestion()"
          >Create Question <mat-icon>arrow_forward</mat-icon></span
        >
        <mat-form-field class="question-bank__filter-menu__tags-container">
          <mat-chip-list #tagList aria-label="Fruit selection">
            <mat-chip
              class="question-bank__filter-menu__tags-container__tags"
              *ngFor="let tag of tags; let tagIndex = index"
              [removable]="true"
              (removed)="removeTag(tagIndex)"
            >
              {{ tag }}
              <mat-icon
                class="question-bank__filter-menu__tags-container__tags--remove"
                matChipRemove
                >cancel</mat-icon
              >
            </mat-chip>
            <input
              placeholder="Tags"
              [matChipInputFor]="tagList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addTag($event)"
            />
          </mat-chip-list>
        </mat-form-field>
      </div>
      <!-- Questions list -->
      <div
        *ngFor="let question of questions; let questionIndex = index"
        class="question-bank__questions-list"
        [ngClass]="{
          'question-bank__questions-list--grid':
            question.question.displayStyle === 2
        }"
        (click)="goToQuestion(question.question.questionId)"
      >
        <div class="question-bank__questions-list__item">
          <span class="question-bank__questions-list__item--title"
            >Question {{ questionIndex + 1 }}</span
          >
          <div
            *ngFor="
              let content of question.question.questionData;
              let questionDataIndex = index
            "
            [ngClass]="{
              'question-bank__questions-list__item--tikz':
                content.type === 'TikZ'
            }"
            class="max-w-78 text-justify"
          >
            <app-multi-data
              [multiData]="{
                type: content.type,
                data: content.data,
                tikzId: 'tikzOutput-' + questionIndex + '-' + questionDataIndex,
                imageKeys: content.images,
                listOfImages: images
              }"
            ></app-multi-data>
          </div>
        </div>
        <!-- Preview for Options -->
        <div class="question-bank__questions-list__item">
          <span class="question-bank__questions-list__item--title"
            >Answers
          </span>
          <!-- <ng-container *ngFor="let optionArray of question.choices"> -->
          <!-- ** MCQ's - questionType = 1 -->
          <ng-container *ngIf="question.question.questionType === 1">
            <div
              *ngFor="let option of question.choices; let optionIndex = index"
              class="question-bank__questions-list__item__option max-w-78 text-justify"
              [ngClass]="{
                'question-bank__questions-list__item__option--correct':
                  option.isAnswer
              }"
            >
              <span class="question-bank__questions-list__item__option--label"
                >{{ optionsText[optionIndex] }})</span
              >
              <div>
                <div
                  *ngFor="let content of option.optionValue; let index = index"
                >
                  <app-multi-data
                    [multiData]="{
                      type: content.type,
                      data: content.data,
                      tikzId:
                        'tikzOutput-option-' +
                        questionIndex +
                        '-' +
                        optionIndex +
                        '-' +
                        index,
                      imageKeys: content.images,
                      listOfImages: images
                    }"
                  ></app-multi-data>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- ** Free response questions = questionType = 2 -->
          <ng-container *ngIf="question.question.questionType === 2">
            <div
              class="question-bank__questions-list__item__option question-bank__questions-list__item__option--correct max-w-78 text-justify"
            >
              <div
                *ngFor="
                  let answer of question.answers.posibilities;
                  let answerIndex = index
                "
              >
                {{
                  answer +
                    (answerIndex < question.answers.posibilities.length - 1
                      ? ","
                      : "")
                }}&nbsp;
              </div>
            </div>
          </ng-container>
          <!-- ** Explanations -->
          <span class="question-bank__questions-list__item--title"
            >Explanations
          </span>
          <div
            *ngFor="
              let option of getExplanationParentArray(
                question.question.questionType,
                question
              );
              let optionIndex = index
            "
            class="question-bank__questions-list__item__option max-w-78 text-justify"
            [ngClass]="{
              'question-bank__questions-list__item__option--correct':
                option.isAnswer,
              'd-none': isExplanationExists(
                question.question.questionType,
                option
              )
            }"
          >
            <div
              *ngIf="
                !isExplanationExists(question.question.questionType, option)
              "
            >
              <div *ngIf="question.question.questionType === 1" class="d-flex">
                <span class="question-bank__questions-list__item__option--label"
                  >{{ optionsText[optionIndex] }})</span
                >
                <div>
                  <div
                    *ngFor="
                      let content of getExplanationArray(
                        question.question.questionType,
                        question,
                        option
                      );
                      let index = index
                    "
                  >
                    <app-multi-data
                      [multiData]="{
                        type: content.type,
                        data: content.data,
                        tikzId:
                          'tikzOutput-option-' +
                          questionIndex +
                          '-' +
                          optionIndex +
                          '-' +
                          index +
                          '-' +
                          index,
                        imageKeys: content.images,
                        listOfImages: images
                      }"
                    ></app-multi-data>
                  </div>
                </div>
              </div>
              <div *ngIf="question.question.questionType === 2" class="d-flex">
                <span
                  *ngIf="question.answers.explanation.length > 1"
                  class="question-bank__questions-list__item__option--label"
                  >{{ optionIndex + 1 }})</span
                >
                <div>
                  <div>
                    <app-multi-data
                      [multiData]="{
                        type: option.type,
                        data: option.data,
                        tikzId:
                          'tikzOutput-freeTextExplanation-' +
                          questionIndex +
                          '-' +
                          optionIndex +
                          '-' +
                          optionIndex,
                        imageKeys: option.images,
                        listOfImages: images
                      }"
                    ></app-multi-data>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </ng-container> -->
        </div>
      </div>
    </ng-container>
    <p-dialog
      [(visible)]="isDataLoading"
      [modal]="true"
      [blockScroll]="true"
      [closeOnEscape]="true"
      [closable]="true"
      [showHeader]="false"
      appendTo="body"
      contentStyleClass="loader"
      styleClass="loaderContainer"
    >
      <!-- <mat-spinner>Please wait</mat-spinner> -->
      <p-progressSpinner strokeWidth="4"></p-progressSpinner>
    </p-dialog>
  </div>
  <app-footer></app-footer>
</div>
